import { render, staticRenderFns } from "./SelectUser.vue?vue&type=template&id=8333bff8&scoped=true&"
import script from "./SelectUser.vue?vue&type=script&lang=ts&"
export * from "./SelectUser.vue?vue&type=script&lang=ts&"
import style0 from "./SelectUser.vue?vue&type=style&index=0&id=8333bff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8333bff8",
  null
  
)

export default component.exports